import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import Footer from "src/components/Marginals/Footer";
import { IFooterContainer } from "src/ScrollyInterface";
import * as actions from "src/store/actions/index";
import {
  IScrollClickedAction,
  IStateApp,
  IToggleSoundAction
} from "src/store/StoreInterface";

class FooterContainer extends React.Component<IFooterContainer, {}> {
  constructor(props: IFooterContainer) {
    super(props);
  }

  public render() {
    const {
      bounce,
      breakpoint,
      content,
      elemNumber,
      muted,
      onScrollClicked,
      onSoundClicked,
      showSideDrawer,
      videoLoaded
    } = this.props;

    return (
      <Footer
        bounce={bounce}
        breakpoint={breakpoint}
        contentId={content.id}
        elemNumber={elemNumber}
        footer={content.footer}
        muted={muted}
        onScrollClicked={onScrollClicked}
        onSoundClicked={onSoundClicked}
        showSideDrawer={showSideDrawer}
        videoLoaded={videoLoaded}
      />
    );
  }
}

const mapStateToProps = (state: IStateApp) => {
  return {
    bounce: state.ui.bounce,
    breakpoint: state.ui.breakpoint,
    content: state.data.content,
    muted: state.ui.muted,
    showSideDrawer: state.ui.showSideDrawer,
    videoLoaded: state.ui.videoLoaded
  };
};

const mapDispatchToProps = (
  dispatch: Dispatch<IScrollClickedAction | IToggleSoundAction>
) => {
  return {
    onScrollClicked: () => dispatch(actions.scrollClicked()),
    onSoundClicked: (muted: boolean) => dispatch(actions.toggleSound(muted))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FooterContainer);



// WEBPACK FOOTER //
// ./src/containers/FooterContainer.tsx